import { render, staticRenderFns } from "./InfoRoomsAndFacilities.vue?vue&type=template&id=38cdba0d&scoped=true"
import script from "./InfoRoomsAndFacilities.vue?vue&type=script&lang=js"
export * from "./InfoRoomsAndFacilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cdba0d",
  null
  
)

export default component.exports